import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio169: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAspectRatio169"><Path d="M22.5 5.5H1.5V18.5H22.5V5.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio169;
